import { McpToolSearchBand } from "@arcadeai/design-system/components/ui/molecules/mcp-server-picker/tool-search-band";
import { FormField } from "@arcadeai/design-system/rhf";
import type { Control } from "react-hook-form";
import { useSuspenseCapability } from "@/app/capabilities/api/hooks";
import type { McpServerCreateRequest } from "../../types";

type DiscoveryFormFieldProps = {
  control: Control<McpServerCreateRequest>;
};

/**
 * Personalized Tool Search (a.k.a. discovery) toggle for the gateway. When on,
 * the gateway advertises Arcade's search/select tools instead of listing every
 * allowed tool up front, and the agent fetches tools on demand. Binds to
 * `tool_filter.discovery.enabled`, which the engine reads on both create and
 * update.
 *
 * Rendered only when the project has the tool-search capability (deploy toggle +
 * org feature flag); otherwise the feature doesn't exist for this deployment and
 * the control is hidden. Capabilities are ensured by the route guard, so this
 * suspense read resolves from cache.
 */
export function DiscoveryFormField({ control }: DiscoveryFormFieldProps) {
  const toolSearch = useSuspenseCapability("tool_search");

  if (!toolSearch?.enabled) {
    return null;
  }

  return (
    <FormField
      control={control}
      name="tool_filter.discovery.enabled"
      render={({ field }) => (
        <McpToolSearchBand
          onToggle={field.onChange}
          state={field.value ? "on" : "off"}
        />
      )}
    />
  );
}
